export const ERROR_CODES = [400, 401, 403, 404, 500, 502, 503] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export function isErrorCode(status?: number): status is ErrorCode {
  return ERROR_CODES.some((code) => code === status);
}
